"use strict";

angular.module("customer")
.controller("CommissionListController", function(
    $scope, $filter, $stateParams, CommissionService, StateExtensionService, moment, IS_MOBILE
) {
    $scope.isMobile = IS_MOBILE;
    $scope.now = moment().format("YYYY-MM-DD");
    $scope.isFilterSubmitted = false;
    if ($stateParams.invoice_date_start && $stateParams.invoice_date_end) {
        $scope.params = angular.extend({}, $stateParams);
    }
    else {
        var defaultStartDate = moment().startOf('day').subtract(7, "days").toISOString();
        var defaultEndDate = moment().toISOString()
        $scope.params = {
            invoice_date_start: defaultStartDate,
            invoice_date_end: defaultEndDate
        };
        StateExtensionService.updateUrlParams($scope.params);
    }
    $scope.userVendor = CommissionService.getUserVendor($scope.params);
    $scope.invoices = CommissionService.query($scope.params);

    $scope.$on("dateFilterUpdated", function(event, dateFilter) {
        StateExtensionService.updateUrlParams(dateFilter);
        $scope.params = angular.extend({}, dateFilter);
        $scope.invoices = CommissionService.query($scope.params);
        $scope.userVendor = CommissionService.getUserVendor($scope.params);
    });
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/commission/commission-list.controller.js
// module id = 906
// module chunks = 0